// Class to debounce repeated calls, throtting the calls
export default class Debouncer {
  // constructor initiating values
  constructor(debounceTime = 0, ensureCompleteCallback = false, callBackFunc = null) {
    // time to elapse before we can try the callback again
    this.debounceTime = debounceTime;

    // instance of the timer
    this.debounceTimer = null;

    this.callBackFunc = callBackFunc;

    this.savedArguments = null;

    // registers that a subsequent try has been made to callback, this is used to determine the
    // final try. upon the end of the timer, if there is no subsequent try we can then call the
    // final callback.
    this.registerSubsequentTry = null;

    // flag to determine if a callback should be called after the completion of sequence of tries,
    // this can be useful if you want to ensure you get a final call back, as this
    // maybe bounced.
    this.ensureCompleteCallback = ensureCompleteCallback;
  }


  // retained call back function
  set callback(func) {
    this.callBackFunc = func;
  }


  // Public method that checks if callback can be called
  debounce(...args) {
    if (this.debounceTimer === null) {
      if (this.callBackFunc !== null) {
        this.callBackFunc(args);
      }

      this.debounceTimer = setTimeout(() => {
        this.onTimeout();
      }, this.debounceTime);
      return true;
    }

    // yes we are getting tries during the current debounce period
    this.registerSubsequentTry = true;
    // save last subsequent tries arguments
    this.savedArguments = args;

    return false;
  }


  // Public method to clean up
  destroy() {
    this.callBackFunc = null;
    clearTimeout(this.debounceTimer);
    this.debounceTimer = null;
  }


  onTimeout() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = null;

    if (this.registerSubsequentTry === true && this.ensureCompleteCallback === true) {
      // reset the subsequent try
      this.registerSubsequentTry = false;
      // call debounced with the quashed last subsequent call
      this.debounce(...this.savedArguments);
      this.savedArguments = null;
    }
  }
}
